import React from "react";
import { Flex, Box } from "@chakra-ui/react";

import { useMenuContext } from "src/contexts/MenuContext";
import { useUser } from "src/contexts/useUser";
import Footer from "./Footer";

export default function SidebarLayout({ children, sidebar }: any) {
  const { menu: { isOpen} } = useMenuContext();
  const { isAdmin } = useUser();

  return (
    <Flex
      height={"100vh"}
      flexDir={"row"}
      align="flex-start"
      width="100vw"
      alignItems={"stretch"}
    >
      <Box
        h="full"
        position="fixed"
        minW={"10px"}
        minH={"100%"}
        bgColor={"brandBlue.500"}
      />
      <Flex
        ml="10px"
        position="sticky"
        top="0"
        mr="5"
        bgColor={isAdmin ? "brandBlue.900" : undefined}
        height="100%"
      >
        <Box
          flex={1}
          overflowY="auto"
          overflowX={"hidden"}
        >
          {sidebar}
        </Box>
      </Flex>

      <Flex
        grow={1}
        maxW={`calc(100vw - ${isOpen ? "350px" : "50px"} - 0.5rem)`}
        height="100%"
        overflowY="auto"
        overflowX="hidden"
        flexDir="column"
      >
        <Box
          flex={1}
          width="full"
        >
          {children}
        </Box>
        <Footer/>
      </Flex>
    </Flex>
  );
}
